import { HTMLAttributes } from "react"

export default function Expo(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      clipRule="evenodd"
      fillRule="evenodd"
      height="2500"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="-9 -27 5310 6303"
      width="2136"
    >
      <path
        d="M1633 1051c87 28 200 103 284 149 77 42 80 31 108 113 17 51 33 105 49 155 70 213 143 430 213 641 96 294 1237 3729 1260 3853-65-24-152-87-216-126-118-73-105-42-161-180l-593-1418c-96-235-725-1778-799-1871-49-38-152 111-207 187-159 219-1119 1489-1154 1574-63-15-219-104-262-145l1479-2932zm136-100c97-82 1059-617 1261-737 99-59 116-96 226-29 61 37 149 89 210 112-56 77-1155 686-1270 752s-102 101-222 27c-66-41-151-77-204-125zM-1 4058c72 46 157 92 244 144 232 140 119 126 779-253l1024-594c52 52 855 2011 999 2357 87 209 111 176 282 281 440 272 262 283 768-12 181-106 1185-667 1203-719 1-87-480-1534-524-1599-138-20-229 6-381-33-709-181-1029-1086-404-1675 192-181 219-58 109-397L3679 288c-25-46-464-315-551-289-43 13-219 125-273 156-357 205-710 407-1069 618-302 177-204 85-388 447L265 3462C204 3582-9 3935 0 4056z"
        fill="#000020"
      />
      <path
        d="M155 3983c43 42 199 131 262 145 35-85 995-1354 1154-1574 55-76 161-226 207-187 74 93 702 1636 799 1871l593 1418c55 138 42 108 161 180 63 39 150 102 216 126-23-124-1163-3559-1260-3853-69-211-142-428-213-641-16-50-32-104-49-155-28-82-31-71-108-113-84-46-197-121-284-149L154 3983z"
        fill="#fff"
      />
      <path
        d="M4511 2213c222-61 562 95 502 289-136 445-647 571-748 507-133-84-287-650 246-797zm21-146c-830 127-617 1386 197 1244 307-54 572-346 513-718-48-305-343-582-710-526z"
        fill="#000020"
      />
      <g fill="#fff">
        <path d="M4511 2213c-533 147-379 712-246 797 101 64 613-63 748-507 59-195-281-350-502-289zM1770 952c52 48 137 84 204 125 121 74 107 39 222-27 116-66 1214-674 1270-752-61-23-149-76-210-112-110-67-127-30-226 29-202 120-1164 655-1261 737z" />
      </g>
    </svg>
  )
}
